import { fromUint8Array } from 'js-base64';
import { gzip } from 'pako';
import { Tool } from './base';

export class MicrosoftDefenderTool extends Tool {
  public readonly toolName = 'Microsoft Defender';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const encodedRenderedContent = fromUint8Array(
      gzip(renderedContent.split('').join('\x00') + '\x00'),
      true
    );
    return `${rootURL}v2/advanced-hunting?query=${encodedRenderedContent}&timeRangeId=day`;
  }
}
